export enum LinkedProductEnum
{
    selfTriage = 1,
    celerus = 2,
    riskClassification = 3,
    telephoneClassification = 4,
    corporateHealth = 5,
    telemedicine = 6,
    trius = 7,
}